import React, { useEffect, useState } from "react";
import EditModal from "@core/modals/EditModal";
import EditButton from "@core/buttons/atoms/EditButton";
import Input from "@core/inputs/Input";
import { showError, showSuccess } from "@utils/helpers";
import { useTranslation } from "react-i18next";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import AuthorizationTypeService from "@services/AuthorizationTypeService";

const EditAuthorizationType = ({ authorizationType, onEdited }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState("");
  const [englishName, setEnglishName] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    setShowModal(false);
    setName("");
    setEnglishName("");
    setDescription("");
  };

  const onSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    AuthorizationTypeService.update(
      authorizationType.id,
      name,
      englishName,
      description
    )
      .then(() => {
        showSuccess(t("authorizationTypeEditedSuccessfully"));
        onEdited();
        closeModal();
      })
      .catch((err) => {
        showError(err.response.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (showModal)
      AuthorizationTypeService.find(authorizationType.id).then((response) => {
        setName(response.data.data.name);
        setEnglishName(response.data.data.name_eng);
        setDescription(response.data.data.description);
      });
  }, [authorizationType.id, showModal]);

  return (
    <PermissionHandler permission={"update_authorization_type"}>
      <EditButton onClick={() => setShowModal(true)} />
      <EditModal
        show={showModal}
        title={t("editAuthorizationType")}
        onClose={closeModal}
        onSubmit={onSubmit}
        loading={loading}
        label={t("edit")}
      >
        <div className="mt-4 sm:mt-8 mb-2 grid grid-cols-2 gap-5">
          <Input
            label={t("authorizationType")}
            placeholder={t("authorizationType")}
            value={name}
            onChange={setName}
            height="h-10"
          />
          <Input
            height="h-10"
            label={t("nameEng")}
            placeholder={t("nameEng")}
            value={englishName}
            onChange={setEnglishName}
          />
          <Input
            label={t("description")}
            placeholder={t("description")}
            value={description}
            onChange={setDescription}
            height="h-10"
          />
        </div>
      </EditModal>
    </PermissionHandler>
  );
};

export default EditAuthorizationType;
